import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { getMessaging, isSupported, type Messaging } from 'firebase/messaging';
import { getRuntimeConfigValue } from '@mbbe/config';

const firebaseConfig = {
  apiKey: getRuntimeConfigValue('FIREBASE_API_KEY', import.meta.env.VITE_FIREBASE_API_KEY),
  authDomain: getRuntimeConfigValue('FIREBASE_AUTH_DOMAIN', import.meta.env.VITE_FIREBASE_AUTH_DOMAIN),
  projectId: getRuntimeConfigValue('FIREBASE_PROJECT_ID', import.meta.env.VITE_FIREBASE_PROJECT_ID),
  messagingSenderId: getRuntimeConfigValue('FIREBASE_MESSAGING_SENDER_ID', import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID),
  appId: getRuntimeConfigValue('FIREBASE_APP_ID', import.meta.env.VITE_FIREBASE_APP_ID),
};

let _auth: Auth | undefined;
let _app: FirebaseApp | undefined;
let _messaging: Messaging | null | undefined;

function getFirebaseApp(): FirebaseApp {
  if (_app) return _app;
  const existingApps = getApps();
  _app = existingApps.length > 0 ? existingApps[0] : initializeApp(firebaseConfig, 'main');
  return _app;
}

export function getFirebaseAuth(): Auth {
  if (_auth) return _auth;
  _auth = getAuth(getFirebaseApp());
  if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true') {
    connectAuthEmulator(_auth, import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL || 'http://127.0.0.1:9099');
  }
  return _auth;
}

export async function getFirebaseMessaging(): Promise<Messaging | null> {
  if (_messaging !== undefined) return _messaging;
  if (!firebaseConfig.messagingSenderId) {
    _messaging = null;
    return _messaging;
  }
  _messaging = (await isSupported()) ? getMessaging(getFirebaseApp()) : null;
  return _messaging;
}

export function getFirebaseWebPushVapidKey(): string {
  return getRuntimeConfigValue('FIREBASE_WEB_PUSH_VAPID_KEY', import.meta.env.VITE_FIREBASE_WEB_PUSH_VAPID_KEY);
}
